import React from 'react';

import MapCities from './components/map/map-cities';
import './App.scss';

function App() {

  return (
    <div className="App">
      <div className="appContainer">
        
        <h2 className="top-title">The World's Wealthiest Cities</h2>
       
        <MapCities />

      </div>
      
    </div>
  );
}

export default App;
